import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PHOTOGRAPHY_CATEGORIES, PORTFOLIO_ITEMS, PhotographyCategory, PortfolioItem } from '../../data/portfolio-data';

declare const jQuery: any;

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PortfolioComponent implements OnInit, AfterViewInit {
  categories = PHOTOGRAPHY_CATEGORIES;
  portfolios = PORTFOLIO_ITEMS;
  selectedCategory?: PhotographyCategory;
  filteredPortfolios: PortfolioItem[] = PORTFOLIO_ITEMS;

  banner = {
    image: '/assets/images/common/hero-bg-2.webp',
    title: 'Photography',
    description: 'People, moments and stories.',
    page: 'Photography'
  };

  footerData = { backExists: '0', wallpaper: '' };

  constructor(private route: ActivatedRoute) {}

  ngAfterViewInit(): void {
    this.initImagePopup();
  }

  private initImagePopup(): void {
    if (typeof jQuery === 'undefined' || !jQuery.fn?.magnificPopup) {
      return;
    }

    jQuery('.mfp-gallery').magnificPopup({
      delegate: '.mfp-link',
      type: 'image',
      tLoading: 'Loading image #%curr%...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1]
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
      }
    });
  }

  private refreshImagePopup(): void {
    requestAnimationFrame(() => requestAnimationFrame(() => this.initImagePopup()));
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const slug = params.get('category');
      this.selectedCategory = slug ? this.categories.find(category => category.slug === slug) : undefined;
      this.filteredPortfolios = this.selectedCategory
        ? this.portfolios.filter(item => item.category === this.selectedCategory?.slug)
        : this.portfolios;

      if (this.selectedCategory) {
        this.banner = {
          image: this.selectedCategory.coverImage ?? '/assets/images/common/hero-bg-2.webp',
          title: this.selectedCategory.name,
          description: this.selectedCategory.description,
          page: this.selectedCategory.name
        };
      } else {
        this.banner = {
          image: '/assets/images/common/hero-bg-2.webp',
          title: 'Photography',
          description: 'People, moments and stories.',
          page: 'Photography'
        };
      }
      this.refreshImagePopup();
    });
  }
}
